import React from "react";

const BindingModal = ({
  isOpen,
  onClose,
  bindingPrices,
  setBindingPrices,
  updateBindingPrices,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h3 className="text-xl font-bold mb-4">Update Binding Prices</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-1">Minimum Pages for Fixed Price</label>
            <input
              type="number"
              value={bindingPrices.minPages}
              onChange={(e) =>
                setBindingPrices({ ...bindingPrices, minPages: parseInt(e.target.value) || 0 })
              }
              className="w-full p-2 border border-gray-300 rounded-md"
              min="1"
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-1">Fixed Price (₹)</label>
            <input
              type="number"
              value={bindingPrices.fixedPrice}
              onChange={(e) =>
                setBindingPrices({
                  ...bindingPrices,
                  fixedPrice: parseFloat(e.target.value) || 0,
                })
              }
              className="w-full p-2 border border-gray-300 rounded-md"
              step="0.5"
              min="0"
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-1">Per Page Price After Minimum (₹)</label>
            <input
              type="number"
              value={bindingPrices.perPagePrice}
              onChange={(e) =>
                setBindingPrices({
                  ...bindingPrices,
                  perPagePrice: parseFloat(e.target.value) || 0,
                })
              }
              className="w-full p-2 border border-gray-300 rounded-md"
              step="0.1"
              min="0"
            />
          </div>
        </div>
        <div className="flex justify-end space-x-2 mt-4">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400">
            Cancel
          </button>
          <button
            onClick={() => {
              updateBindingPrices();
              onClose();
            }}
            className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
          >
            Update Prices
          </button>
        </div>
      </div>
    </div>
  );
};

export default BindingModal;
